import React, { useEffect, useRef } from 'react';

import { useGlobalSearchParams, useRouter } from 'expo-router';
import { View } from 'react-native';

import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { useAuthContext } from 'state/auth';
import { ModalAuthTrigger } from 'state/auth/types';
import { animatedSplashScreenHiddenDeferred } from 'utils/hide-splash-screen';
import { routes } from 'utils/routing';

export default function AuthDeeplink() {
  const { loading, isAuthenticated, openSignInModal } = useAuthContext();
  const { replace } = useRouter();
  const { redirect } = useGlobalSearchParams<{ redirect?: string }>();
  const hasHandledDeeplink = useRef(false);

  useEffect(() => {
    if (loading || hasHandledDeeplink.current) {
      return;
    }

    hasHandledDeeplink.current = true;
    replace(routes.base);

    if (isAuthenticated) {
      return;
    }

    const navigateOnSuccessRoute =
      typeof redirect === 'string' && redirect.startsWith('/') ? redirect : undefined;

    void animatedSplashScreenHiddenDeferred.promise.then(() => {
      openSignInModal({
        trigger: ModalAuthTrigger.Global,
        navigateOnSuccessRoute,
      });
    });
  }, [isAuthenticated, loading, openSignInModal, redirect, replace]);

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <LoyaltyLoader />
    </View>
  );
}
